<template>
  <div class="content-wrapper-scroll">
    <div class="content-wrapper">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <h5>Compliance Report</h5>
            </div>
            <div class="card-body">
              <div class="row gutters">
                <div class="col-sm-3">
                  <div class="field-wrapper">
                    <search
                      :class="{ 'is-invalid': errors.frequency_id }"
                      :customClass="{ 'is-invalid': errors.frequency_id }"
                      :initialize="meta.frequency_id"
                      id="frequency_id"
                      label="frequency_name"
                      placeholder="Select Frequency"
                      :data="frequencies"
                      @input="selectFrequency($event)"
                    >
                    </search>
                    <span v-if="errors.frequency_id" class="invalid-feedback">{{
                      errors.frequency_id[0]
                    }}</span>
                    <div class="field-placeholder">Frequency</div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="field-wrapper">
                    <div class="field-placeholder">From Date</div>
                    <input
                      class="form-control form-control-sm"
                      type="date"
                      v-model="meta.from_date"
                    />
                    <span v-if="errors.from_date" class="invalid-feedback">{{
                      errors.from_date[0]
                    }}</span>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="field-wrapper">
                    <div class="field-placeholder">To Date</div>
                    <input
                      class="form-control form-control-sm"
                      type="date"
                      v-model="meta.to_date"
                    />
                    <span v-if="errors.to_date" class="invalid-feedback">{{
                      errors.to_date[0]
                    }}</span>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="field-wrapper">
                    <search
                      :class="{ 'is-invalid': errors.department_id }"
                      :customClass="{ 'is-invalid': errors.department_id }"
                      :initialize="meta.department_id"
                      id="department_id"
                      label="department_name"
                      placeholder="Select Department"
                      :data="departments"
                      @input="
                        (departments) => (meta.department_id = departments)
                      "
                    >
                    </search>
                    <span
                      v-if="errors.department_id"
                      class="invalid-feedback"
                      >{{ errors.department_id[0] }}</span
                    >
                    <div class="field-placeholder">Department</div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="field-wrapper">
                    <search
                      :class="{ 'is-invalid': errors.functional_id }"
                      :customClass="{ 'is-invalid': errors.functional_id }"
                      :initialize="meta.functional_id"
                      id="functional_id"
                      label="functional_name"
                      placeholder="Select Functional"
                      :data="functionals"
                      @input="
                        (functionals) => (meta.functional_id = functionals)
                      "
                    >
                    </search>
                    <span
                      v-if="errors.functional_id"
                      class="invalid-feedback"
                      >{{ errors.functional_id[0] }}</span
                    >
                    <div class="field-placeholder">Functional</div>
                  </div>
                </div>
                <div class="col-sm-9">
                  <div class="input-group field-wrapper">
                    <input
                      class="form-control"
                      type="text"
                      placeholder="Search for Template Name"
                      v-model="meta.search"
                    />
                    <span class="input-group-text">
                      <i class="fas fa-search"></i>
                    </span>
                    &nbsp;
                    <div class="field-placeholder">Template Name</div>
                  </div>
                </div>
              </div>
              <div class="form-actions-footer">
                <div class="text-end">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="getComplianceReport"
                  >
                    Search
                  </button>
                  <button type="button" class="btn btn-danger" @click="reset">
                    Reset
                  </button>
                  <a
                    target="_blank"
                    :href="
                      $store.getters.pdfUrl +
                      'report/compliance?plant_id=' +
                      meta.plant_id +
                      '&from_date=' +
                      meta.from_date +
                      '&to_date=' +
                      meta.to_date +
                      '&department_id=' +
                      meta.department_id +
                      '&functional_id=' +
                      meta.functional_id +
                      '&section_id=' +
                      meta.section_id +
                      '&frequency_id=' +
                      meta.frequency_id +
                      '&search=' +
                      meta.search +
                      '&report_type=PDF'
                    "
                    class="btn btn-success"
                  >
                    PDF
                  </a>
                  <a
                    target="_blank"
                    :href="
                      $store.getters.pdfUrl +
                      'report/compliance?plant_id=' +
                      meta.plant_id +
                      '&from_date=' +
                      meta.from_date +
                      '&to_date=' +
                      meta.to_date +
                      '&department_id=' +
                      meta.department_id +
                      '&functional_id=' +
                      meta.functional_id +
                      '&section_id=' +
                      meta.section_id +
                      '&frequency_id=' +
                      meta.frequency_id +
                      '&search=' +
                      meta.search +
                      '&report_type=Excel'
                    "
                    class="btn btn-secondary"
                  >
                    Excel
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="row gutters">
                <div class="col-sm-12">
                  <iframe
                    :src="source"
                    style="width: 100%; height: 800px"
                    frameborder="0"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Search from "@/components/Search.vue";
import moment from "moment";
export default {
  components: { Search },
  data() {
    return {
      meta: {
        plant_id: this.$store.getters.user.plant_id,
        functional_id: "",
        // from_date: moment().add(-6, "days").format("YYYY-MM-DD"),
        // to_date: moment().format("YYYY-MM-DD"),
        from_date: moment().subtract(1, 'weeks').startOf('isoWeek').format('YYYY-MM-DD'),
				to_date: moment().subtract(1, 'weeks').endOf('isoWeek').format('YYYY-MM-DD'),
        department_id: "",
        frequency_id: "",
        search: "",
        report_type: "Data",
      },
      source: "",
      templates: [],
      departments: [],
      functionals: [],
      frequencies: [],
      errors: [],
    };
  },
  mounted() {
    let vm = this;
    if (vm.$route.query.from_date) {
      vm.meta.from_date = vm.$route.query.from_date;
    }
    if (vm.$route.query.to_date) {
      vm.meta.to_date = vm.$route.query.to_date;
    }
    if (vm.$route.query.department_id) {
      vm.meta.department_id = vm.$route.query.department_id;
    }
    if (vm.$route.query.plant_id) {
      vm.meta.plant_id = vm.$route.query.plant_id;
    }
    if (vm.$route.query.frequency_id) {
      vm.meta.frequency_id = vm.$route.query.frequency_id;
    }
    vm.getDepartment();
  },

  methods: {
    getDepartment() {
      let vm = this;
      vm.$store
        .dispatch("post", { uri: "getDepartmentsPlantWise", data: vm.meta })
        .then(function (response) {
          vm.departments = response.data.data;
          vm.getFunctions();
        })
        .catch(function (error) {
          vm.errors = error.response.data.errors;
          vm.$store.dispatch("error", error.response.data.message);
        });
    },

    getFunctions() {
      let vm = this;
      vm.$store
        .dispatch("post", { uri: "getFunctionalsPlantWise", data: vm.meta })
        .then(function (response) {
          vm.functionals = response.data.data;
          vm.getFrequencies();
        })
        .catch(function (error) {
          vm.errors = error.response.data.errors;
          vm.$store.dispatch("error", error.response.data.message);
        });
    },

    getFrequencies() {
      let vm = this;
      vm.$store
        .dispatch("post", { uri: "getFrequenciesPlantWise", data: vm.meta })
        .then(function (response) {
          vm.frequencies = response.data.data;
          if (vm.meta.frequency_id == "") {
            vm.meta.frequency_id = vm.frequencies[0].frequency_id;
          }
          vm.getComplianceReport();
        })
        .catch(function (error) {
          vm.errors = error.response.data.errors;
          vm.$store.dispatch("error", error.response.data.message);
        });
    },

    selectFrequency(e) {
      let vm = this;
      vm.meta.frequency_id = e;
    },

    getComplianceReport() {
      let vm = this;
      vm.source =
        vm.$store.state.pdfUrl +
        "report/compliance?from_date=" +
        vm.meta.from_date +
        "&to_date=" +
        vm.meta.to_date +
        "&plant_id=" +
        vm.meta.plant_id +
        "&department_id=" +
        vm.meta.department_id +
        "&frequency_id=" +
        vm.meta.frequency_id +
        "&functional_id=" +
        vm.meta.functional_id +
        "&search=" +
        vm.meta.search +
        "&report_type=Data";

        console.log(vm.source)
    },

    reset() {
      let vm = this;
      vm.meta.department_id = "";
      vm.meta.functional_id = "";
      vm.meta.search = "";
      vm.errors = [];
      vm.search();
    },
  },
};
</script>

<style scoped>
.btnn {
  margin-top: 0.5rem;
}
</style>
